import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const checklist = ['You are a mom of kids between 3 and 6 years old', 'You are looking for simple ideas', 'You want simple ideas you can set up quickly', 'You care about your kids learning while they play', 'You need variety for those days stuck at home'];
export function WhoIsItFor() {
  return <>
      <section className="py-20 px-4 sm:px-6 lg:px-8" data-id="element-74">
        <div className="max-w-4xl mx-auto" data-id="element-75">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} className="bg-white rounded-[2.5rem] p-8 md:p-12 shadow-soft relative overflow-hidden border border-brand-sage/10" data-id="element-76">
            {/* Decorative elements */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-pastel-yellow rounded-full mix-blend-multiply filter blur-3xl opacity-50 transform translate-x-1/2 -translate-y-1/2" data-id="element-77"></div>
            <div className="absolute bottom-0 left-0 w-64 h-64 bg-pastel-green rounded-full mix-blend-multiply filter blur-3xl opacity-50 transform -translate-x-1/2 translate-y-1/2" data-id="element-78"></div>

            <div className="relative z-10" data-id="element-79">
              <h2 className="text-3xl md:text-4xl font-bold text-center mb-10" data-id="element-80">
                Perfect For You If...
              </h2>

              <ul className="space-y-6 max-w-2xl mx-auto" data-id="element-81">
                {checklist.map((item, index) => <motion.li key={index} initial={{
                opacity: 0,
                x: -20
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                duration: 0.4,
                delay: index * 0.1
              }} className="flex items-start gap-4" data-id="element-82">
                    <div className="flex-shrink-0 w-8 h-8 rounded-full bg-brand-sage/20 flex items-center justify-center mt-0.5" data-id="element-83">
                      <CheckIcon className="w-5 h-5 text-brand-sage" strokeWidth={3} data-id="element-84" />
                    </div>
                    <span className="text-lg md:text-xl text-brand-brown-dark font-medium leading-tight pt-1" data-id="element-85">
                      {item}
                    </span>
                  </motion.li>)}
              </ul>
            </div>
          </motion.div>
        </div>
      </section>
    </>;
}